import ResourceLink from 'components/common/digitalResourcesMaps/resourceLink';
import React, { useCallback } from 'react';
import { IDResource, MapGroupProps } from 'types';
import { getPictureByUrl, onFaviconError } from 'utils/helpers/resourcesMap';

const MathLink: React.FC<MapGroupProps> = ({
  resources,
  onHoveredElementChanged,
  onClick,
}) => {
  const onElementHover = useCallback(
    (resource?: IDResource, target?: SVGElement) => {
      if (onHoveredElementChanged) {
        onHoveredElementChanged(resource, target);
      }
    },
    [onHoveredElementChanged]
  );

  const resource1SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <path
        fill="#FFF"
        stroke="#E11E52"
        strokeMiterlimit="10"
        strokeWidth="4"
        d="M168.4 283.3l-34.8 9.1c-9 2.4-18.2-3-20.5-12l-9-34.5c-2.4-9 3-18.2 12-20.5l34.8-9.1c9-2.4 18.2 3 20.5 12l9 34.5c2.4 8.9-3 18.1-12 20.5z"
      />
      <image
        width="56"
        height="56"
        x="114.5"
        y="227"
        transform="rotate(-14.67 142.5 255)"
        href={getPictureByUrl(resources[0]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource2SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <path
        fill="#FFF"
        stroke="#E11E52"
        strokeMiterlimit="10"
        strokeWidth="4"
        d="M247.8 288.7l-34.9-2.9c-9.5-.8-16.6-9.2-15.9-18.7l2.8-34.5c.8-9.5 9.2-16.6 18.7-15.9l34.9 2.9c9.5.8 16.6 9.2 15.9 18.7l-2.8 34.5c-.8 9.6-9.2 16.7-18.7 15.9z"
      />
      <image
        width="56"
        height="56"
        x="205"
        y="225"
        transform="rotate(4.72 233 253)"
        href={getPictureByUrl(resources[1]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource3SVGComponent = (
    <g
      className="icon-link"
      pointerEvents="none"
      transform="translate(290 220) rotate(4.72)"
    >
      <rect
        x="0"
        y="0"
        width="67"
        height="67"
        rx="13.34"
        fill="#fff"
        stroke="#E11E52"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="54"
        height="54"
        transform="translate(6.5 6.5)"
        href={getPictureByUrl(resources[2]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource4SVGComponent = (
    <g
      className="icon-link"
      pointerEvents="none"
      transform="translate(85 300) rotate(5.8)"
    >
      <rect
        x="0"
        y="0"
        width="67"
        height="67"
        rx="13.34"
        fill="#fff"
        stroke="#E11E52"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="54"
        height="54"
        transform="translate(6.5 6.5)"
        href={getPictureByUrl(resources[3]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );
  const resource5SVGComponent = (
    <g
      className="icon-link"
      pointerEvents="none"
      transform="translate(160 303) rotate(-10.47)"
    >
      <rect
        x="0"
        y="0"
        width="67"
        height="67"
        rx="13.34"
        fill="#fff"
        stroke="#E11E52"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="54"
        height="54"
        transform="translate(6.5 6.5)"
        href={getPictureByUrl(resources[4]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource6SVGComponent = (
    <g
      className="icon-link"
      pointerEvents="none"
      transform="translate(257 295) rotate(10.4)"
    >
      <rect
        x="0"
        y="0"
        width="67"
        height="67"
        rx="13.34"
        fill="#fff"
        stroke="#E11E52"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="54"
        height="54"
        transform="translate(6.5 6.5)"
        href={getPictureByUrl(resources[5]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  return (
    <g className="digital-resources-math" transform="translate(0, 90)">
      <defs>
        <linearGradient
          id="a53660c0-44a4-44da-b239-d12cad333ac9"
          data-name="grad-28"
          x1="478.29"
          y1="133.01"
          x2="478.68"
          y2="181.37"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.08" stopColor="#f4cb76" />
          <stop offset="1" stopColor="#bf534f" />
        </linearGradient>
        <linearGradient
          id="a85fd562-1e1f-417a-b0ac-24c92dae550c"
          x1="475.18"
          y1="148.77"
          x2="475.39"
          y2="175.49"
          xlinkHref="#a53660c0-44a4-44da-b239-d12cad333ac9"
        />
        <linearGradient
          id="a7db096e-3b63-465c-9694-9ff19fc5f6da"
          x1="478.41"
          y1="155.24"
          x2="477.47"
          y2="190.35"
          xlinkHref="#a53660c0-44a4-44da-b239-d12cad333ac9"
        />
      </defs>
      <g id="ec976bd5-8651-4fe5-806f-1b54e1bae7d5" data-name="math">
        <g>
          <path
            d="M546.7,180.41S192.81,212.49,280.39,352.63c-309.21,13.51-286-11.82-273.46-43.05s84-103.84,84-103.84Z"
            fill="#5a9e94"
          />
          <path
            d="M559.8,179.54c-2.25,5.08-8,10.78-16.25,16.66C524.16,210,491,224.82,457.4,234.67c-.65.2-1.3.38-1.95.57l-2.34.66c-1.71.49-3.42.95-5.12,1.4q-5.12,1.35-10.19,2.53l-.33.07c-1.93.45-3.84.88-5.75,1.28l-3.71.75-.56.11-.19,0-.56.11c-18.14,3.49-35.15,4.91-48.77,3.23-11.11-1.37-22.58-2.85-34.32-4.24-7.09-.84-14.29-1.65-21.57-2.38-7.87-.79-15.85-1.5-23.92-2.05C268.63,234.7,238,234.56,207,239a303.92,303.92,0,0,0-35.49,7.24c-17.37,4.66-34.84,10.24-52.15,15.82-34.18,11-67.75,22.05-98.71,26l-1.19.14A176.14,176.14,0,0,1,0,289.6V127.26C1.64,124.52,2.58,123,2.58,123,2,107.09,8.05,96.43,17.64,89.41c12.2-8.92,30.07-12,47-12.38,4.84-.12,9.61,0,14.14.18l2.27.13c.64,0,1.27.07,1.9.12,3,.2,5.89.46,8.58.74l2.7.3c3,.35,5.64.72,8,1.07,6,.91,9.75,1.72,9.8,1.75,1,.65,2.08,1.28,3.16,1.89s2.3,1.28,3.49,1.89A135.54,135.54,0,0,0,149,95.77c21.45,5.07,46.75,7.2,73,7.56,11.51.15,23.21,0,34.85-.46,19.39-.72,38.64-2.1,56.64-3.71,11.08-1,21.68-2.06,31.56-3.11q8.31-.89,15.88-1.73a14.65,14.65,0,0,1,1.77-.1c11-.2,25.84,8.3,39.75,16.34,1.79,1,3.56,2.07,5.31,3.07,9.33,5.33,17.91,9.89,24.17,10.69s12.48,1.65,18.33,2.51q19,2.76,34.41,5.85,3.79.76,7.39,1.56c3.2.71,6.28,1.43,9.25,2.18,13.71,3.44,24.93,7.3,33.86,11.79,12.81,6.43,20.92,14.15,25,23.76A9.28,9.28,0,0,1,559.8,179.54Z"
            fill="#3dd87c"
          />
          <path
            d="M561.38,169.8a8.47,8.47,0,0,1,.8,5.1,15.93,15.93,0,0,1-1.72,5l.11-.39a.78.78,0,0,1-.23.55l.11-.14a37.47,37.47,0,0,1-5.8,7.87,80.87,80.87,0,0,1-7.11,6.63,152.27,152.27,0,0,1-15.68,11.34c-5.43,3.45-11,6.65-16.7,9.65-2.83,1.53-5.7,3-8.57,4.41s-5.8,2.78-8.73,4.1-5.87,2.61-8.82,3.9-5.93,2.46-8.93,3.62c-6,2.34-12.06,4.6-18.13,6.58-6.19,2.14-12.35,3.78-18.58,5.6-1.56.46-3.09.84-4.61,1.22l-2.3.57-1.14.29-.58.15-.88.2-4.66,1.05-2.43.53-2.32.48-1.29.11-.1,0,1.26-.11c-5.38,1.07-10.81,2-16.33,2.63A162.37,162.37,0,0,1,391.26,252q-4.26.09-8.59-.18c-1.45-.09-2.9-.21-4.36-.36l-4-.44-15.91-1.76,1.05.07H359l-.66-.07L337,247l-10.68-1.15c-3.56-.37-7.1-.6-10.65-.91-7.09-.57-14.18-1.22-21.27-1.72s-14.16-.78-21.23-1c-28.26-.73-56.46.78-84,6.15-6.9,1.31-13.64,2.91-20.57,4.71s-13.79,3.6-20.67,5.54l-41.49,11.82c-6.95,2-13.93,3.87-20.95,5.66s-14.06,3.52-21.17,5-14.25,2.87-21.43,4-14.43,1.9-21.67,2.37h0c-3.54.22-7.09.3-10.62.31s-7.07-.11-10.59-.38q5.27-.46,10.48-1.19c3.47-.48,6.92-1.11,10.35-1.74h0l.18,0h-.16C49,279,75.92,269.21,103,259.52q10.14-3.67,20.33-7.3c6.79-2.43,13.61-4.84,20.48-7.13s13.77-4.58,20.75-6.68,14.14-4.11,21.32-5.77c28.84-6.6,58.5-8.9,87.78-8.18,7.32.16,14.63.44,21.91.93s14.52,1.26,21.77,1.88c3.62.35,7.27.58,10.87,1l10.77,1.35,21.54,2.7-1.05-.07h.67l.4.06,15.84,2.21,3.94.54c1.19.16,2.39.3,3.61.41q3.64.31,7.4.4a146.34,146.34,0,0,0,15.18-.5c5.1-.4,10.23-1,15.36-1.78l.22,0,1-.08h.1l-1.29.11,2.35-.37,2.24-.37,4.67-.8a1.1,1.1,0,0,1,.28,0l.59-.12,1.17-.23,2.35-.46c1.56-.31,3.13-.62,4.63-1,6-1.38,12.24-2.62,18.15-4.28,12.13-3.17,24-6.89,35.85-11.1a335.53,335.53,0,0,0,34.64-14.51,169.31,169.31,0,0,0,16.34-9.14,78.44,78.44,0,0,0,7.53-5.5,36,36,0,0,0,6.46-6.59l.11-.14a.69.69,0,0,0-.21.51l.11-.39a15,15,0,0,0,2.23-4.38A8.17,8.17,0,0,0,561.38,169.8Z"
            fill="#dcf9f7"
          />
          <path
            d="M63,124.32c28.3-2.15,111.25-7.59,158,11s67.87-13.29,122-9S470.59,160,478,170.76s-83,34.31-125.48,31.1-92.27-7.87-142.1.35S109.51,225.44,70.14,219,63,124.32,63,124.32Z"
            fill="#3db57c"
          />
          <g>
            <path
              d="M443.28,176.69s16.08,15.69,64.45,4.75c4-.9,5.66-5.18,2.95-7.88C496.33,159.22,432.2,165.52,443.28,176.69Z"
              fill="#531063"
              opacity="0.47"
            />
            <g>
              <path
                d="M511.51,176.92a4.48,4.48,0,0,0,1.38-8.42c-3.83-1.91-8.89-2.73-13.31-.84,13.11-5.62,19.82-12.48,11.24-18.72-6.87-5-17.48,13.1-20,13.1s1.24-7.48,6.86-14.35,5-12.48.62-14.35-11.85,1.24-13.73,20.59c0-3.12,1.25-22.47-3.74-20.59s-8.74,12.48-.62,23.71c-5,1.87-4.37-3.12-4.37-3.12s-2.5-18.72-11.24-15-6.24,13.73,0,20,6.24,10-1.87,6.25-11.86-12.49-19.35-3.75,13.11,19.35,25,20C477,181.84,499.67,178.69,511.51,176.92Z"
                fill="url(#a53660c0-44a4-44da-b239-d12cad333ac9)"
              />
              <path
                d="M504,175.23c.44-3.55-6.21-7.09-11.53-2.66,8-7.09,9.76-12.86,5.77-12.86s-12.86,7.54-14.63,7.54,3.91-3.45,7.9-8.33,1.85-8.65-1.25-10c-2.91-1.25-11.73,1.55-14,13.15a2.06,2.06,0,0,1-1.38,1.54c-.69.22-1.47-1.59-1.47-1.59s-4-15.18-10.2-12.52-4.43,9.75,0,14.18,4.44,7.1-1.33,4.44-8.42-8.87-13.74-2.66,6.2,9.31,14.63,9.75S504,175.23,504,175.23Z"
                fill="url(#a85fd562-1e1f-417a-b0ac-24c92dae550c)"
              />
              <path
                d="M488.47,180.2c-1.67-.6,4.85-1.92,10.26-5.15s4.68-7.52,2.21-9.82c-2.32-2.16-11.57-2.52-17.63,7.63a2,2,0,0,1-1.82,1c-.73,0-.85-2-.85-2s1.39-15.64-5.35-15.24-7.48,7.68-4.81,13.35,1.77,8.18-2.75,3.72-4.92-11.2-12-7.16,2.69,10.86,10.46,14.13S490.14,180.8,488.47,180.2Z"
                fill="url(#a7db096e-3b63-465c-9694-9ff19fc5f6da)"
              />
            </g>
          </g>
        </g>
        <g>
          <ellipse
            cx="84.5"
            cy="183.82"
            rx="17.5"
            ry="6.5"
            fill="#531063"
            opacity="0.47"
          />
          <path
            d="M94.87,180.62c0,3.43-6.27,6.21-14,6.21s-14-2.78-14-6.21c0-.71.06-2.78.06-2.78s7.82-3.42,13.95-3.42,14,3.36,14,3.36S94.87,179.88,94.87,180.62Z"
            fill="#98baf5"
          />
          <ellipse cx="80.85" cy="178.02" rx="14.02" ry="6.2" fill="#b0dff6" />
          <path
            d="M80.4,176.48c1.16,1.05,11.49-2.48,11.49-2.48s-3.87-1.44-4.56-1.62a41.11,41.11,0,0,0-8.08,2.48Z"
            fill="#90a3f4"
          />
          <path
            d="M81,177.13H78.77V21.47L80.84,0l2.1,21.47V175.23A1.9,1.9,0,0,1,81,177.13Z"
            fill="#b0dff6"
          />
          <path
            d="M80.84,0l-1,9.88L81,21.64V177.13h0a1.9,1.9,0,0,0,1.9-1.91V21.47Z"
            fill="#98baf5"
          />
          <rect
            x="47.54"
            y="50.1"
            width="66.04"
            height="3.58"
            rx="1.79"
            transform="translate(-7.95 15.17) rotate(-10.25)"
            fill="#b0dff6"
          />
          <path
            d="M57.88,57.84s6,13.13,7.17,21.48-5.37,30.42,0,46.52,29.22,27.43,29.22,27.43l12.53-22.06,31.61,7.15s-16.11-11.92-18.49-28,0-36.38-3-45.32S106.79,48.9,106.79,48.9Z"
            fill="#c02352"
          />
          <path
            d="M57.58,54.21a2.43,2.43,0,0,1,.31,3.64c6.8-1.2,16.7-3,16.7-3s1.78-2.2-.59-3.58C68.52,52.08,57.58,54.21,57.58,54.21Z"
            fill="#9c236c"
          />
          <path
            d="M90.09,48.25a2.43,2.43,0,0,1,.31,3.64l16.7-3s1.77-2.19-.6-3.57C101,46.11,90.09,48.25,90.09,48.25Z"
            fill="#9c236c"
          />
          <path
            d="M78.77,21.47V32a4.15,4.15,0,0,0,2.59.56c.41,0,1.18-.22,1.58-.26V21.47L80.84,0Z"
            fill="#d2ddef"
          />
          <path
            d="M113.74,115.69c2.59-.3,5-.52,7.28-.67a30.48,30.48,0,0,1-1.1-4.69c-2.39-16.1,0-36.38-3-45.32-.14-.4-.28-.8-.43-1.19-4.3,4.75-21.11,14.26-31.59,16.29C75,82,69.35,84.2,64.31,92.2c-1.19,10.11-2.76,23.14.74,33.64A24.72,24.72,0,0,0,66.34,129C77.4,128.47,101.94,117.08,113.74,115.69Z"
            fill="#ad2352"
          />
          <g>
            <path
              d="M74.54,101.45l-.12-6c0-2-.11-4.09-.2-6.24a3,3,0,0,0-.31-1.38,1,1,0,0,0-1-.35,7.34,7.34,0,0,0-1.38.22,7.91,7.91,0,0,0-1.94.76,2.36,2.36,0,0,0-.87.8,3.57,3.57,0,0,0-.31,1.39q-.14,3.25-.17,6.26c0,2,0,4,0,6s0,4.21.11,6.31.2,4.3.35,6.57a2.35,2.35,0,0,0,.41,1.33,1.19,1.19,0,0,0,1.23.27,17.5,17.5,0,0,0,2.84-.8,1.82,1.82,0,0,0,1.13-.86,4.18,4.18,0,0,0,.24-1.62c0-1.1,0-2.17,0-3.22v-6.29C74.57,103.54,74.56,102.5,74.54,101.45Z"
              fill="#f4da34"
            />
            <path
              d="M95.47,106.7a1.35,1.35,0,0,0-.42-.88,1.14,1.14,0,0,0-1-.11l-.5.13-.69.18-.75.2-.59.14-5.41,1.36c1-1.75,2-3.56,3-5.43s1.9-3.67,2.7-5.37,1.45-3.26,1.94-4.65A10.72,10.72,0,0,0,94.52,89a4.72,4.72,0,0,0-1.11-3.33A5.94,5.94,0,0,0,90.53,84a11.85,11.85,0,0,0-2.26-.36,21.73,21.73,0,0,0-2.27,0,15.32,15.32,0,0,0-2,.18l-1,.18-.44.1a2.66,2.66,0,0,0-1.23.56,1.34,1.34,0,0,0-.23.29,2.76,2.76,0,0,0-.32.69c-.25.73-.47,1.45-.66,2.14s-.35,1.3-.46,1.8-.14.65-.16.78,0,.23,0,.32c0,.61.36.88,1.08.79l.53-.07c.63-.08,1.26-.13,1.9-.16s1,0,1.52,0a14.21,14.21,0,0,1,3.69.48q-2,4.53-4.16,8.5c-.35.63-.69,1.26-1,1.89-.62,1.13-1.25,2.26-1.9,3.37-.47.84-1,1.68-1.45,2.51a6.78,6.78,0,0,0-.67,1.34,3.9,3.9,0,0,0-.15.82c0,.14,0,.3,0,.46s0,.45,0,.67v.61c0,.42,0,.83,0,1.21,0,.07,0,.13,0,.2,0,.32.06.65.1,1a1.47,1.47,0,0,0,.52,1.06,1.74,1.74,0,0,0,1,.22l.68-.07c.67-.07,1.3-.15,1.9-.24l.63-.09c1-.16,1.88-.32,2.69-.47,1.33-.26,2.6-.55,3.81-.88s2.54-.71,4-1.13a2,2,0,0,0,1-.58,2.52,2.52,0,0,0,.45-1.26,15.12,15.12,0,0,0,.14-2.17A11,11,0,0,0,95.47,106.7Z"
              fill="#73beee"
            />
            <path
              d="M114.75,93.53a9,9,0,0,0-4.68-2,9,9,0,0,0,2.2-1.77,11.41,11.41,0,0,0,1.6-2.2,10.29,10.29,0,0,0,1-2.35,9.54,9.54,0,0,0,.31-2c0-.12,0-.23,0-.34a3.89,3.89,0,0,0-.93-2.71,5.06,5.06,0,0,0-2.45-1.44,11.06,11.06,0,0,0-3.52-.34,21.51,21.51,0,0,0-4.14.62l-.84.21a7.76,7.76,0,0,0-.82.25l-.27.11a3.59,3.59,0,0,0-1,.55,4.66,4.66,0,0,0-1,1.47,16.53,16.53,0,0,0-.89,2.14c-.15.46-.29.92-.42,1.4-.09.31-.17.63-.25,1a4.3,4.3,0,0,0-.11.85.9.9,0,0,0,.28.79.76.76,0,0,0,.63.09,10,10,0,0,0,1.09-.33l.29-.1a19.92,19.92,0,0,1,2.26-.64,19.23,19.23,0,0,1,2.56-.42,8.21,8.21,0,0,1,2.39.1,10.94,10.94,0,0,1-2.46,2.88A16.11,16.11,0,0,1,103,91c-.35.19-.72.37-1.1.55a4,4,0,0,0-1.11.76,2.71,2.71,0,0,0-.53,1.41,9.3,9.3,0,0,0-.11.94c0,.33,0,.65,0,1a9.29,9.29,0,0,0,.11,1.42c.13.7.34,1.12.65,1.24a1.83,1.83,0,0,0,1.08.06c.42-.09.73-.17.94-.23l.61-.15a12.16,12.16,0,0,1,3.37-.3,3.21,3.21,0,0,1,1,.19,2.92,2.92,0,0,1,1.41.93l-.43.45a17.89,17.89,0,0,1-1.53,1.37,25.48,25.48,0,0,1-2.48,1.75c-.88.55-1.78,1.07-2.7,1.55a24.92,24.92,0,0,1-2.59,1.19,1.74,1.74,0,0,0-1.31,1.62,2.82,2.82,0,0,0,.15.89,9.46,9.46,0,0,0,.71,1.9c.26.46.57,1,.94,1.51a2.17,2.17,0,0,0,.82.87,1.39,1.39,0,0,0,.9.12,5.87,5.87,0,0,0,.83-.32c.43-.18.85-.37,1.24-.56s.91-.45,1.45-.75,1.13-.64,1.74-1,1.24-.81,1.88-1.28,1.27-1,1.87-1.46a23.12,23.12,0,0,0,1.94-1.88,19.11,19.11,0,0,0,2.2-2.83,9.08,9.08,0,0,0,1.59-5A4.53,4.53,0,0,0,114.75,93.53Z"
              fill="#e38cb6"
            />
          </g>
          <path
            d="M113.09,46.22,113,45.8a1.56,1.56,0,0,0-1.83-1.27l-.13,0,.06.21.07.42A1.57,1.57,0,0,1,109.91,47L48.16,58.18a1.56,1.56,0,0,0,1.78,1.06l61.88-11.19A1.58,1.58,0,0,0,113.09,46.22Z"
            fill="#b0dff6"
            opacity="0.5"
            style={{ mixBlendMode: 'multiply' }}
          />
          <path
            d="M80.84,0,80.4,4.62,81.9,20l.21,11.23a13.18,13.18,0,0,1-1.76.06A7.68,7.68,0,0,1,78.77,31v1a4.15,4.15,0,0,0,2.59.56c.41,0,1.18-.22,1.58-.26V21.47Z"
            fill="#bfd0ee"
          />
          <path
            d="M83.14,31.7c0,.53-1,.95-2.27.95s-2.28-.42-2.28-.95"
            fill="none"
            stroke="#d2ddef"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <g className="text">
          <path
            d="M266.42,215.88a76.18,76.18,0,0,0-1.53-7.71,67.41,67.41,0,0,0-2.3-7.35,2.67,2.67,0,0,0-.59-1,1.72,1.72,0,0,0-1-.38l-.34,0h-.37l-.73,0c-.26,0-.54,0-.82.07a1.81,1.81,0,0,0-1.55,1.13,28.25,28.25,0,0,0-1.42,4.15c-.36,1.39-.7,2.78-1,4.17-.41-1.46-.81-2.87-1.23-4.24a41.2,41.2,0,0,0-1.48-4.06,2.18,2.18,0,0,0-.63-.92,1.58,1.58,0,0,0-.9-.33,2.06,2.06,0,0,0-.35,0h-.38c-.25,0-.5,0-.76,0s-.53,0-.81.08a1.77,1.77,0,0,0-1,.35,1.94,1.94,0,0,0-.47.82q-1.28,3.92-2.25,7.6a74.93,74.93,0,0,0-1.54,7.44c0,.1,0,.19,0,.27a2.28,2.28,0,0,0,0,.26,1,1,0,0,0,1,1.07c.35.07.72.12,1.1.17a12.51,12.51,0,0,0,1.28.06q.83,0,1.05-.33a2.13,2.13,0,0,0,.3-1c.24-1.88.48-3.62.73-5.24s.56-3.18.93-4.66q.64,2.47,1.26,4.9a47.82,47.82,0,0,0,1.49,4.77,1.89,1.89,0,0,0,.66.93,2.09,2.09,0,0,0,1.22.3,9.11,9.11,0,0,0,1.81-.2,1.59,1.59,0,0,0,.84-.43,2.66,2.66,0,0,0,.46-.83q.82-2.35,1.44-4.71c.41-1.57.77-3.15,1.07-4.73.43,1.72.82,3.43,1.15,5.13s.64,3.42.93,5.14q.12.7.54.84a3.44,3.44,0,0,0,1.06.14,10.73,10.73,0,0,0,1.28-.08,6.54,6.54,0,0,0,1.2-.25.9.9,0,0,0,.7-1A2,2,0,0,0,266.42,215.88Z"
            fill="#fff"
          />
          <path
            d="M280.82,205.74a1.16,1.16,0,0,0-.22-.46,1.14,1.14,0,0,0-.37-.27,3,3,0,0,0-.53-.18,9.3,9.3,0,0,0-1.3-.27,8,8,0,0,0-1.13-.1.65.65,0,0,0-.5.16,1.14,1.14,0,0,0-.2.64,5.56,5.56,0,0,0-2.21-.45,6.11,6.11,0,0,0-2.63.59,7.69,7.69,0,0,0-2.28,1.61,8,8,0,0,0-1.61,2.41,7.23,7.23,0,0,0-.62,3,6.05,6.05,0,0,0,.35,2.08,4.63,4.63,0,0,0,2.66,2.75,5.8,5.8,0,0,0,2.15.38,5.66,5.66,0,0,0,2-.35,6.4,6.4,0,0,0,1.78-1,1.81,1.81,0,0,0,.15.83c.1.18.39.31.86.37a2.17,2.17,0,0,0,.38,0h1a2.67,2.67,0,0,0,.51-.05,1.36,1.36,0,0,0,.91-.39,2.05,2.05,0,0,0,.36-1c.19-1.54.32-3.14.4-4.81s.13-3.25.13-4.74A3.45,3.45,0,0,0,280.82,205.74Zm-4.33,5c0,.67-.06,1.32-.1,2a3.86,3.86,0,0,1-1.2.84,3.29,3.29,0,0,1-1.25.26,2.22,2.22,0,0,1-1.62-.55,2,2,0,0,1-.56-1.51,3.12,3.12,0,0,1,.21-1.07,3.85,3.85,0,0,1,.61-1.08,3.68,3.68,0,0,1,1-.84,2.62,2.62,0,0,1,1.34-.34,4.15,4.15,0,0,1,.91.1,6,6,0,0,1,.75.25C276.55,209.39,276.53,210.05,276.49,210.72Z"
            fill="#fff"
          />
          <path
            d="M290.6,206.3a1.09,1.09,0,0,0-.7-.31l-.89-.12c-.29,0-.58-.05-.86-.09,0-.29,0-.62.05-1s0-.67.05-1,0-.45,0-.63a1.09,1.09,0,0,1,0-.18c0-.23,0-.38,0-.47a1.38,1.38,0,0,0-.22-.84,1,1,0,0,0-.81-.29,13.9,13.9,0,0,0-1.81.1,2.94,2.94,0,0,0-1,.31,1,1,0,0,0-.42.42.42.42,0,0,0,0,.1,3,3,0,0,0-.14.8c0,.37,0,.71,0,1s0,.64,0,.95v.71a7.77,7.77,0,0,0-.8.11,1.06,1.06,0,0,0-.48.21.8.8,0,0,0-.23.4,2.53,2.53,0,0,0-.07.68c0,.13,0,.29,0,.47s0,.37,0,.56a1.08,1.08,0,0,0,.29.76,1.4,1.4,0,0,0,.77.24l.65.07c.08,1.24.18,2.44.28,3.59s.25,2.32.42,3.51a1.28,1.28,0,0,0,.31.81,1.07,1.07,0,0,0,.72.21,12.16,12.16,0,0,0,1.9-.15,1.1,1.1,0,0,0,.71-.3,1,1,0,0,0,.19-.67c0-.17,0-.52,0-1.06s-.06-1.13-.11-1.8-.07-1.36-.11-2.08-.06-1.35-.07-1.91c.13,0,.33,0,.58,0s.51,0,.74-.08a1.66,1.66,0,0,0,.81-.23,1.18,1.18,0,0,0,.35-.69c0-.24.06-.49.09-.77s0-.49,0-.66A1.09,1.09,0,0,0,290.6,206.3Z"
            fill="#fff"
          />
          <path
            d="M304.33,207.42a2.91,2.91,0,0,0-1.35-2.1,3.51,3.51,0,0,0-1.26-.47,6.84,6.84,0,0,0-1.19-.12,7.41,7.41,0,0,0-2.15.32,6,6,0,0,0-1,.39,6.13,6.13,0,0,0-.95.57c0-.26,0-.53,0-.81s0-.66,0-1c0-.64,0-1.24,0-1.8s0-1.06.05-1.49,0-.73,0-.88a1,1,0,0,0-.1-.51c-.07-.13-.23-.19-.5-.19l-.73,0-.85.07c-.28,0-.56.05-.83.09a5.62,5.62,0,0,0-.7.12.72.72,0,0,0-.59.51,5.8,5.8,0,0,0-.11,1c0,.85-.07,1.73-.11,2.63,0,.12,0,.24,0,.36q-.06,1.17-.06,2.37c0,.95,0,1.89,0,2.81s.06,1.8.1,2.64.09,1.62.15,2.33.12,1.33.17,1.84a1.8,1.8,0,0,0,.31.91,1.43,1.43,0,0,0,1,.35l.38,0H295l.38,0a2,2,0,0,0,1.07-.28.83.83,0,0,0,.26-.65,2.09,2.09,0,0,0,0-.25c0-.08,0-.18,0-.28-.08-.75-.14-1.68-.17-2.8s-.06-2.32-.08-3.61a5,5,0,0,1,2.68-.93.79.79,0,0,1,.72.37,1.71,1.71,0,0,1,.24,1c0,1.79-.05,3.22-.14,4.29s-.14,1.69-.14,1.88a1,1,0,0,0,.8,1.1c.37.08.76.14,1.18.19s.74.06,1,.06c.43,0,.71-.12.84-.37a2.28,2.28,0,0,0,.23-.78c.1-.74.19-1.48.27-2.23s.13-1.48.17-2.17.08-1.34.1-2,0-1.12,0-1.57A4.19,4.19,0,0,0,304.33,207.42Z"
            fill="#fff"
          />
        </g>
      </g>
      {/* LINKS */}
      {resources && (
        <g className="resources-wrap" transform="translate(65, -175)">
          <ResourceLink
            r={resources[0]}
            svgComponent={resource1SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[0], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[1]}
            svgComponent={resource2SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[1], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[2]}
            svgComponent={resource3SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[2], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[3]}
            svgComponent={resource4SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[3], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[4]}
            svgComponent={resource5SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[4], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[5]}
            svgComponent={resource6SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[5], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
        </g>
      )}
    </g>
  );
};
export default MathLink;
